<template>
    <div class="card p-3 border-radius-xl" data-animation="FadeIn">
        <h5 class="font-weight-bolder mb-0">Notificações</h5>
        <p class="mb-3 text-sm">Selecione abaixo a categoria de notificações desejada.</p>
        <div class="col-12 col-sm-12 mt-3 mt-sm-0">
            <!-- <label>Categoria</label> -->
            <select id="choices-gender" v-model="selectedNotification" class="multisteps-form__select form-control"
                name="choices-gender" :disabled="loading" @change="filterNotifications">
                <option selected="selected"></option>
                <option v-for="notification in notifications" :key="notification.id" :value="notification.id">{{
                    notification.name }}</option>
            </select>
            <div v-if="categorizedNotifications && categorizedNotifications.length <= 0"
                class="d-flex flex-column align-items-center justify-content-center mb-4 mt-5 row">
                Nada aqui, por enquanto!
            </div>
            <div v-if="categorizedNotifications">
                <div v-for="categorizedNotification in categorizedNotifications"
                    :key="categorizedNotification.client_notification_id">
                    <div class="notification-content">
                        <div class="row">
                            <div class="col-lg-1 col-3">
                                <div class="d-flex flex-column align-items-center justify-content-center">
                                    <div class="d-flex flex-column align-items-center justify-content-center row">
                                        <i class="fa fa-bell fa-2x" aria-hidden="true"></i>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center row">
                                        <span style="font-size: 12px;">
                                            {{ formatRelativeTime(categorizedNotification.created_at) }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-11 col-9">
                                <div class="row font-weight-bolder">
                                    {{ categorizedNotification.notification_html }}
                                </div>
                                <div class="row">
                                    {{ categorizedNotification.notification }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import axios from 'axios';
import { useStore } from "vuex";
import { onMounted, computed, ref } from 'vue';
import Choices from "choices.js";

const store = useStore();
const contractData = computed(() => store.getters.getCurrentContract);

const loading = ref(false)
const selectedNotification = ref(null);
const categorizedNotifications = ref(null)
const allNotifications = ref(null)
const notifications = ref([
    { name: 'RELACIONAMENTO', id: 4 },
    { name: 'FINANCEIRAS', id: 5 },
    { name: 'OBRA', id: 6 },
    { name: 'DOCUMENTOS', id: 7 },
    { name: 'VISITA À OBRA', id: 8 },
    { name: 'ENTREGA', id: 9 },
    { name: 'ASSISTÊNCIA TÉCNICA', id: 10 },
    { name: 'PERSONALIZAÇÃO', id: 11 },
    { name: 'VISTORIA TÉCNICA', id: 12 }
]);

onMounted(() => {
    getNotifications();
    if (document.getElementById("choices-gender")) {
        var state_element = document.getElementById("choices-gender");
        new Choices(state_element, {
            searchEnabled: false,
            allowHTML: true,
            itemSelectText: 'Pressione para selecionar',
            placeholder: true,
            placeholderValue: 'Estado Civil',
        });
    }
});

const getNotifications = async () => {
    try {
        loading.value = true;
        const response = await axios.get(`/notification/category?contract_id=${contractData.value.contrato_id}&per_page=30`);
        allNotifications.value = response.data
    } catch (error) {
        console.log(error);
    } finally {
        // showToast('Dados Atualizado.', 'success');
        loading.value = false;
    }
};

const filterNotifications = () => {
    let categorized = allNotifications.value.find(obj => obj.id == selectedNotification.value);
    categorizedNotifications.value = categorized.notifications.data
};

const formatRelativeTime = (datetime) => {
    const providedDate = new Date(datetime);
    const difference = Date.now() - providedDate.getTime();
    const timeUnits = [
        { unit: "sem", seconds: 604800 },
        { unit: "d", seconds: 86400 },
        { unit: "h", seconds: 3600 },
        { unit: "min", seconds: 60 }
    ];

    for (const { unit, seconds } of timeUnits) {
        const unitDifference = Math.floor(difference / (1000 * seconds));
        if (unitDifference > 0) {
            return unitDifference === 1 ? `1 ${unit}` : `${unitDifference} ${unit}`;
        }
    }

    const minutesDifference = Math.floor(difference / (1000 * 60));
    return `${minutesDifference} min`;
};

</script>

<style>
.notification-content {
    padding: 10px;
    border-radius: 10px;
    transition: background-color 0.3s ease;
}

.notification-content:hover {
    cursor: pointer;
    background-color: #f5f2f2;
}
</style>